module.exports = __webpack_public_path__ + "static/media/average-team-score-icon.ed0f0cc5.svg";